import BzbsApi from "@/core/Http/BzbsApi"
import { computed, ref } from "vue"

//#region type def
/**
 * @typedef {Object} GetTheOneProfile
 * @property {string} uniqueRefID
 * @property {string} authCode
 */

/**
 * @typedef {Object} RedeemTheOneParams
 * @property {string} points
 * @property {string} walletcard
 * @property {string} info1
 * @property {string} info2
 * @property {string} info3
 * @property {string} info4
 * @property {string} info5
 * @property {string} withholdingtax_key
 */
//#endregion

export const useTheOne = function (states) {
    const baseUrl = ref('')
    const userTheOne = ref(null)
    const userPoints = ref(0)
    const hasSignedIn = computed(() => {
        if (userTheOne.value != null) {
            return true
        }

        return false
    })

    const initService = function () {
        baseUrl.value = states.blobWebLanding[states.mainAppName]
    }

    const updatePoints = function (data) {
        let newPoints = data?.updated_points?.points ?? 0
        if (newPoints != 0) {
            userPoints.value = newPoints
        }
    }

    const methods = {
        checkToken: function () {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/check_token"
                BzbsApi.connectBzbsPost(url, states.query.token, null, states.query.jwt).subscribe({
                    next: (res) => {
                        // console.log(res)
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        },
        /**
         *
         * @param {GetTheOneProfile} params
         * @returns
         */
        getProfile: function (params) {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/profile"
                BzbsApi.connectBzbsGet(url, states.query.token, params, states.query.jwt).subscribe({
                    next: (res) => {
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        },
        /**
         *
         * @returns {Promise}
         */
        login: function () {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/login"
                BzbsApi.connectBzbsPost(url, states.query.token, states.query, states.query.jwt).subscribe({
                    next: (res) => {
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        },
        logout: function () {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/signout"
                BzbsApi.connectBzbsPost(url, states.query.token, null, states.query.jwt).subscribe({
                    next: (res) => {
                        resolve(res.data)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        },
        /**
         *
         * @param {RedeemTheOneParams} params
         * @returns
         */
        redeem: function (params) {
            return new Promise((resolve, reject) => {
                let url = baseUrl.value + "/redeem"
                BzbsApi.connectBzbsPost(url, states.query.token, params, states.query.jwt).subscribe({
                    next: (res) => {
                        resolve(res)
                    },
                    error: (err) => {
                        reject(err)
                    }
                })
            })
        }
    }

    return {
        methods,
        initService,
        userTheOne,
        hasSignedIn,
        userPoints,
        updatePoints
    }
}

export default useTheOne
